<template>
    <div
        v-if="value"
        class="EntityItemDetail"
    >
        <div
            v-for="({ headerName, children }) in normalizeSchema"
            :key="headerName"
            class="Form"
        >
            <WText
                tag="label"
                typo="label"
                weight="semi"
                color="accent-blue"
                size="14"
                uppercase
                class="Title"
            >
                {{ headerName }}
            </WText>

            <template v-if="children">
                <div class="Group flex flex-wrap">
                    <div
                        v-for="({ headerName: label, field, type, value: fieldValue }) in children"
                        :key="field"
                        class="Field"
                    >
                        <WText
                            tag="label"
                            typo="label"
                            :size="14"
                            class="Label"
                        >
                            {{ label }}
                        </WText>

                        <div
                            v-if="outputs.email === type"
                            class="Value"
                        >
                            <a :href="`mailto:${fieldValue}`">
                                <WText
                                    v-if="fieldValue"
                                    color="accent-blue"
                                    ellipsis
                                >
                                    {{ fieldValue }}
                                </WText>
                            </a>
                        </div>
                        <div
                            v-else-if="outputs.link === type"
                            class="Value"
                        >
                            <a
                                :href="fieldValue"
                                target="_blank"
                            >
                                <WText
                                    v-if="fieldValue"
                                    color="accent-blue"
                                    ellipsis
                                >
                                    {{ fieldValue }}
                                </WText>
                            </a>
                        </div>
                        <div
                            v-else
                            class="Value"
                        >
                            <WText v-if="fieldValue">
                                {{ fieldValue }}
                            </WText>
                        </div>
                    </div>
                </div>
            </template>
        </div>

        <slot />
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import moment from 'moment'
import {
    INPUTS, FIELD_INPUTS, FIELD_OUTPUTS, FORMATS,
} from '@/entities/fields'

export default {
    name: 'EntityItemDetail',
    props: {
        value: VueTypes.any,
        columns: VueTypes.array,
        selectGroups: VueTypes.any,
        entityKey: VueTypes.string,
        loading: VueTypes.bool,
    },
    data () {
        return {
            outputs: FIELD_OUTPUTS,
        }
    },
    computed: {
        normalizeSchema () {
            return (this.columns || []).map(this.normalizeField)
        },
    },
    methods: {
        normalizeField ({
            headerName, children, type, field,
        }) {
            return {
                headerName,
                children: children ? children.map(this.normalizeField) : undefined,
                ...(field ? {
                    type,
                    field,
                    value: this.normalizeFieldValue({ type, field }),
                } : {}),
            }
        },
        normalizeFieldValue ({ type, field }) {
            const value = this.value[field]
            if (!value || (Array.isArray(value) && !value.length)) return '-'
            if (FIELD_INPUTS[type] === INPUTS.SELECT) return value.join(', ')
            if (FIELD_INPUTS[type] === INPUTS.DATE) return moment(value).format(FORMATS[INPUTS.DATE])
            if (FIELD_INPUTS[type] === INPUTS.DATETIME) return moment(value).format(FORMATS[INPUTS.DATETIME])
            return value
        },
    },
}
</script>
<style lang="scss" scoped>
.Group {
    margin-bottom: 15px;
}

.Field {
    width: 100%;
    max-width: 175px;
    padding: 10px 0 0 5px;
    box-sizing: border-box;
}

.WText.Title {
    display: block;
    margin-bottom: 5px !important;
    padding: 5px;
    background: $gray-06;
    border-radius: $border-radius;
}

.Label {
    margin-bottom: 5px !important;
}

.Value {
    overflow: hidden;
}
</style>
